import type { EventStatus } from '@upme/contracts';

export const STATUS_LABEL: Record<EventStatus, string> = {
  DRAFT: 'Черновик',
  PENDING_MODERATION: 'На модерации',
  PUBLISHED: 'Опубликовано',
  ARCHIVED: 'В архиве',
};

export const STATUS_VARIANT: Record<EventStatus, 'default' | 'secondary' | 'outline'> = {
  DRAFT: 'outline',
  PENDING_MODERATION: 'outline',
  PUBLISHED: 'default',
  ARCHIVED: 'secondary',
};

export function formatEventDateTime(iso: string, timezone: string, hasStartTime = true): string {
  const fmt = new Intl.DateTimeFormat('ru-RU', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(hasStartTime ? { hour: '2-digit' as const, minute: '2-digit' as const } : {}),
  });
  return fmt.format(new Date(iso));
}

// Returns local date+time components in a given timezone, suitable for
// pre-filling <input type="date"> and <input type="time"> separately.
export function toLocalDateTimeParts(iso: string, timezone: string): { date: string; time: string } {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(iso));
  const map: Record<string, string> = {};
  for (const p of parts) {
    if (p.type !== 'literal') map[p.type] = p.value;
  }
  return {
    date: `${map.year}-${map.month}-${map.day}`,
    time: `${map.hour}:${map.minute}`,
  };
}

export function formatPrice(price: number | null, currency: string): string {
  if (price == null) return 'бесплатно';
  try {
    return new Intl.NumberFormat('ru-RU', { style: 'currency', currency, maximumFractionDigits: 0 }).format(
      price,
    );
  } catch {
    return `${price} ${currency}`;
  }
}
